import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=c65f1cea&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BFormInput, BFormGroup, BButton, BInputGroupAppend, BInputGroup, BCol, BRow, BForm} from 'bootstrap-vue'
    installComponents(component, {BAlert, BFormInput, BFormGroup, BButton, BInputGroupAppend, BInputGroup, BCol, BRow, BForm})
    

export default component.exports